import React from 'react';
import PropTypes from 'prop-types';
import './UserViewsTable.scss';

const renderUser = (user) => {
  const data = [];
  if (user.name) {
    data.push(user.name);
  }

  data.push(user.email);

  return (
    <div className="user-name-email">
      <div className="top medium-weight">{data[0]}</div>
      { data[1]
        && <div className="bottom normal-weight mt-4">{data[1]}</div>}
    </div>
  );
};

const renderView = (userView) => (
  <tr
    className="user-view-entry"
    key={userView.id}
    id={userView.id}
  >
    <td className="user">{renderUser(userView.user)}</td>
    <td className="view-count">{userView.view_count}</td>
    <td className="last-view">{moment(userView.updated_at).format('M/D/YYYY')}</td>
  </tr>
);

function UserViewsTable({ userViews, userHeader = 'User' }) {
  return (
    <div className="user-views-panel style-guide box-shadow-1">
      <h3>
        Activity & Views
      </h3>
      <table className="user-views-table mt-18">
        <tr>
          <th>{userHeader}</th>
          <th>Views</th>
          <th>Last View</th>
        </tr>
        <tbody>
          {userViews.map((userView) => renderView(userView))}
        </tbody>
      </table>
    </div>
  );
}

UserViewsTable.propTypes = {
  userViews: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  userHeader: PropTypes.string,
};

UserViewsTable.defaultProps = {
  userHeader: 'User',
};

export default UserViewsTable;
